import { css } from '@linaria/core';
import { Intents } from '@ux/intents';
const intents = new Intents();

export const classes = {
  default: css`
    border-width: 1px !important;
    border-style: solid !important;
    border-radius: 4px !important;
  `,
  stack: css`
    border-width: 0px 1px 1px 1px !important;
    border-style: solid !important;
    border-radius: 0px !important;

    &:first-of-type {
      border-top-width: 1px !important;
      border-top-left-radius: 4px !important;
      border-top-right-radius: 4px !important;
    }
    &:last-of-type {
      border-bottom-width 1px !important;
      border-bottom-left-radius: 4px !important;
      border-bottom-right-radius: 4px !important;
    }
  `,
  defaultBorder: css`
    border-color: ${intents.ux.boxLowContrast.borderColor} !important;
  `
};

export default (props = {}) => ({
  [classes.default]: !props.stack,
  [classes.stack]: props.stack,
  [classes.defaultBorder]: !props.bd && !props.border
});
